import { render, staticRenderFns } from "./liveStreaming.vue?vue&type=template&id=e98236aa&scoped=true"
import script from "./liveStreaming.vue?vue&type=script&lang=js"
export * from "./liveStreaming.vue?vue&type=script&lang=js"
import style0 from "./liveStreaming.vue?vue&type=style&index=0&id=e98236aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98236aa",
  null
  
)

export default component.exports